import * as React from 'react'
import './App.css'
import Box from '@mui/material/Box'
import NavigationTabs from './components/Tabs'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import { Routes, Route } from 'react-router'
import About from './pages/About'
import Contact from './pages/Contact'
import Projects from './pages/Projects'
import Home from './pages/Home'
import { ConfigProvider } from './hooks/useConfig'

function App() {
    return (
        <ConfigProvider>
            <ScrollToTop />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    flex: '1',
                }}
            >
                <Header />
                <NavigationTabs />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
                <Footer />
            </Box>
        </ConfigProvider>
    )
}

export default App
